import { h, render } from "preact";
import { useState, useEffect } from "preact/hooks";

import { Grid, Typography, Box, Paper, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import NavPrimaryButton from "../../theme/NavPrimaryButton";
import NavSecondaryButton from "../../theme/NavSecondaryButton";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	margin: {
		margin: theme.spacing(1),
	},
	withoutLabel: {
		marginTop: theme.spacing(3),
	},
	textField: {},
}));

export default function InscriptionVendeur(props) {
	const classes = useStyles();
	const [values, setValues] = useState({
		login: "",
		password: "",
		showPassword: false,
	});

	const handleChange = (prop) => (event) => {
		setValues({ ...values, [prop]: event.target.value });
	};

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	return (
		<Grid container style="min-height: 500px">
			<Grid item xs={12}>
				<Box display="flex" justifyContent="center" mx="auto" m={1} p={1}>
					<Typography variant="h2">Alors comme ça on veut vendre son petit paradis ?</Typography>
				</Box>
			</Grid>
			<Grid item xs={12}>
				{" "}
				<Box style="min-height: 500px" display="flex" justifyContent="center" alignItems="center">
					<Paper elevation={3} style="width: 400px; padding: 10px">
						<Box display="flex" justifyContent="center" flexDirection="column">
							<FormControl className={clsx(classes.margin, classes.textField)} variant="outlined" hiddenLabel>
								<InputLabel htmlFor="outlined-adornment-password">Login</InputLabel>
								<OutlinedInput
									id="login"
									type="text"
									value={values.login}
									onChange={handleChange("login")}
									fullWidth
									labelWidth={100}
								/>
							</FormControl>

							<FormControl className={clsx(classes.margin, classes.textField)} variant="outlined" hiddenLabel>
								<InputLabel htmlFor="outlined-adornment-password">Mot de passe</InputLabel>
								<OutlinedInput
									id="password"
									type={values.showPassword ? "text" : "password"}
									value={values.password}
									onChange={handleChange("password")}
									fullWidth
									endAdornment={
										<InputAdornment position="end">
											<IconButton
												aria-label="Permet l'affichage du mot de passe"
												onClick={handleClickShowPassword}
												onMouseDown={handleMouseDownPassword}
												edge="end"
											>
												{values.showPassword ? <Visibility /> : <VisibilityOff />}
											</IconButton>
										</InputAdornment>
									}
									labelWidth={100}
								/>
							</FormControl>

							<NavSecondaryButton style="margin-left: 20px; padding: 10px">Je passe au bien !</NavSecondaryButton>
						</Box>
					</Paper>
				</Box>
			</Grid>
		</Grid>
	);
}
